import request from '@/utils/request';

export default {
    // 查询字典列表  查询参数（如 carTask/dic/getDicList?value=123）
    getDicList: (params) => request.get(`carTask/dic/getDicList/`,{params}),
    // 添加字典信息
    addDic: (params) => request.post(`carTask/dic/addDic/` , params),
    // 字典信息状态取反
    updateStatus: (params) => request.put(`carTask/dic/updateStatus/` + params),
    // 查询字典类型列表
    getDicTypeList: (params) => request.get(`carTask/dic/getDicTypeList/`,{params}),
    // 添加字典类型
    addDicType: (params) => request.post(`carTask/dic/addDicType/?name=` + params),
    // 获取司机车辆列表
    getInfosByName: (params) => request.get(`baseInfo/getInfosByName` , {params}),
    // 新增或修改车辆信息
    insOrUpdateVehicle: (params) => request.post(`baseInfo/insOrUpdateVehicle` , params),
    // 新增或编辑任务
    insOrUpdateCarTask: (params) => request.post(`carTasks/insOrUpdateCarTask` , params),
    // 计算运费
    getAmountByConditions: (startPort,endPort,taskType) => request.post(`template/getAmountByConditions/?startPort=` + startPort + `&endPort=` + endPort +'&taskType=' + taskType),
    // 查询调度任务中的费用明细
    getFeeList: (params) => request.get(`carTaskFee/getFeeList/` + params),
    // 新增或修改任务费用
    insOrUpdateCarTaskFee: (params) => request.post(`carTaskFee/insOrUpdateCarTaskFee` , params),
    // 删除费用信息
    deleteCarTaskFee: (params) => request.delete(`carTaskFee/deleteCarTaskFee/` + params),
    //  文件上传
    uploadAttachments: (taskId,createMan,params) => request.post(`carTaskFile/uploadAttachments/?taskId=` + taskId + `&type=PC&createMan=` + createMan,params),
    // 删除上传文件
    deleteAttachmentById: (params) => request.delete(`carTaskFile/deleteAttachmentById/` + params),
    // 获取已上传的文件列表
    getAttachments: (taskId) => request.get(`carTaskFile/getAttachments/` + taskId ),
    // 查询调度任务详情
    getCarTaskDetail: (taskId) => request.get(`carTasks/getCarTaskDetail/` + taskId ),
    // 获取调度任务列表
    getCarList: (pageNum,pageSize,params) => request.post(`carTasks/getCarList/` + pageNum + `/` + pageSize,params),
    // 取消任务--删除
    cancelTask: (params) => request.put(`carTasks/cancelTask/` + params),
    // 查询地址详细信息
    getAddressBy: (params) => request.get(`carTasks/getAddressBy/?address=` + params),
    // 查询司机信息
    getDriverByName: (params) => request.get(`baseInfo/getDriverByName/?driverName=` + params),
    // 将司机状态置为空闲
    changeWorkStatus: (id) => request.put(`baseInfo/changeWorkStatus/` + id),
    // 获取空闲司机
    getFreeDrivers: (id) => request.get(`baseInfo/getFreeDrivers`),
    // 发布调度任务
    publishTask: (id) => request.put(`carTasks/publishTask/` + id),
    // 撤回调度任务
    undoTask: (id) => request.put(`carTasks/undoTask/` + id),
    // 获取司机工资表
    getSalaryList: (params) => request.post(`carTaskReport/getSalaryList` , params),
    // 获取司机运费表
    getTemplate: (params) => request.get(`template/getTemplate/` , {params}),
    // 运费表详情
    getTemplateDetailById: (params) => request.get(`template/getTemplateDetailById/` + params),
    // 删除运费表明细
    deleteOneRecord: (params) => request.delete(`template/deleteOneRecord/` + params),
    // 保存运费表
    saveOrUpdateTemplate: (params) => request.post(`template/saveOrUpdateTemplate` , params),
    // 获取员工电脑信息
    managementGetAll: () => request.get(`/management/getAll`),
    // 新增或修改送货地址信息
    insOrUpdatePort: (params) => request.post(`/baseInfo/insOrUpdatePort`, params),
    // 查询地址信息
    getPortsBy: (pageNum, pageSize, params) => request.post(`/baseInfo/getPortsBy/`+ pageNum + '/' + pageSize,params),
    // 批量导入申报要素
    insSample: (params) => request.post(`/sample/insSample`, params),
    // 根据海关编码获取要素表
    getHsCiqByHsCode: (params) => request.get(`/cms/declare/getHsCiqByHsCode/` + params ),
    // getElementByCode: (params) => request.get(`/sample/getElementByCode?code=` + params ),
    // 模块管理页面
    // 根据角色查询权限
    getModuleList: (params) => request.get(`/sys/getModuleList`, params),
    // 删除模块
    deleteById: (id) => request.delete(`/sys/deleteById/`+ id),
    // 新增或修改模块
    insModule: (params) => request.post(`/sys/insModule`, params),
    // 获取树形菜单
    getTreeMenuList: ( ) => request.get(`/sys/getTreeMenuList`),
    // 万华物料
    // 获取万华物料信息分页信息
    getGoodsInfo: ( page, limit, params ) => request.get(`/task/getGoodsInfo/`+ page + '/' + limit , {params}),
    // 用户管理
    // 更新用户角色关联
    insRelations: ( username, params ) => request.post(`/sys/insRelations/?username=`+ username , params),
    // 新增或修改用户
    insUser: ( params ) => request.post(`/sys/insUser`, params),
    // 根据用户名获取角色列表
    getRoleByUser: ( userName ) => request.get(`/sys/getRoleByUser/`+ userName ),
    // 获取所有用户
    getUserList: (  ) => request.get(`/sys/getUserList`),
    // 操作日志
    // 分页查询操作日志
    getLogList: ( pageNum, pageSize, params ) => request.post(`/sampleLog/getLogList/`+ pageNum + '/' + pageSize, params),
    // 更改车辆状态
    changeStatusBaseInfo: ( id ) => request.put(`/baseInfo/changeStatus/`+ id),
    // 建发edi
    getDongShengStock: (  ) => request.post(`/cnCdStock/getDongShengStock`),
    // 企业信息
    // 删除企业信息
    deleteCompany: ( id ) => request.delete(`/company/deleteCompany/`+ id),
    // 新增或修改企业信息
    saveOrUpdateCompany: ( params ) => request.post(`/company/saveOrUpdateCompany`, params),
    // 根据企业名称查询企业信息
    getCompanyList: ( params ) => request.get(`/company/getCompanyList`, {params}),
    // 司机管理
    // 司机离职
    changeDriverStatus: ( id ) => request.put(`/baseInfo/changeDriverStatus/`+ id),
    // 新增或修改司机信息
    insOrUpdateDriver: ( params ) => request.post(`/baseInfo/insOrUpdateDriver`, params),
    // 获取司机信息
    getDriverByName: ( params ) => request.get(`/baseInfo/getDriverByName`, {params}),
    // 角色管理
    // 更新角色的权限
    updateModuleByRole: ( roleName,params ) => request.post(`/sys/updateModuleByRole/`+roleName , params),
    // 根据角色获取权限列表
    getModuleList: ( params ) => request.get(`/sys/getModuleList`,{params}),
    // 新增或修改角色
    insRole: ( params ) => request.post(`/sys/insRole`,params),
    // 返回所有角色列表
    getRoleList: (  ) => request.get(`/sys/getRoleList`),
    // 登录
    login: ( name, pwd ) => request.post(`/sys/login?name=` + name + '&pwd=' + pwd + '&type=PC'),
    // 退出登陆,要带着设备类型一起传过来
    logout: (  ) => request.post(`/sys/logout?type=PC`,),
    // 根据登录用户名获取菜单列表
    getMenusByUser: (  ) => request.get(`/sys/getMenusByUser`),
    // 获取期间单量数据
    getBillNums: ( startDate,endDate ) => request.get(`/bigView/getBillNums/` + startDate + '/' + endDate),
    // 获取期间单量折线图数据
    getBillNumsLineReport: ( startDate,endDate ) => request.get(`/bigView/getBillNumsLineReport/` + startDate + '/' + endDate),
    // 查询司机历史位置
    getLocations: ( params,startDate,endDate ) => request.get(`/baseInfo/getLocations/` + startDate + '/' + endDate,{params}),
    // 查询可接单司机
    getFreeDrivers: ( params ) => request.get(`/carTaskFile/getFreeDrivers`,{params}),
    // 指派司机
    assignedTask: ( taskId, driver, truckNo ) => request.put(`/carTasks/assignedTask/`+ taskId + '/' + driver + '/' + truckNo ),
    // 新增日期--文件管理
    insCmsBill: ( params ) => request.post(`/cms/files/insCmsBill`,params ),
    // 查询日期列表 -- 文件管理
    getCmsBill: (  ) => request.get(`/cms/files/getCmsBill`),
    //  文件多选上传--文件管理
    uploadFiles: (billId, params) => request.post(`/cms/files/uploadFiles/?billId=` + billId ,params),
    // 获取文件 -- 文件管理
    getFiles: (billId) => request.get(`/cms/files/getFiles/` + billId),
    // 删除附件-- 文件管理
    deleteFileBy: (id) => request.delete(`/cms/files/deleteFileBy/` + id),
     // 进口货物申报
    declareDecXml: (params) => request.post(`cms/declare/declareDecXml` , params),
    // 获取国内关区信息--海关
    getCnCustoms: (params) => request.get(`/cms/baseInfo/getCnCustoms` , {params}),
    // 获取国家信息
    getNationDescBy: (params) => request.get(`/cms/baseInfo/getNationDescBy` , {params}),
    // 港口信息
    getPort: (params) => request.get(`/cms/baseInfo/getPort` , {params}),
    // 口岸信息
    getCnPort: (params) => request.get(`/cms/baseInfo/getCnPort` , {params}),
    // 监管方式/贸易方式
    getTradeMode: (params) => request.get(`/cms/baseInfo/getTradeMode` , {params}),
    // 征免性质
    getCutMode: (params) => request.get(`/cms/baseInfo/getCutMode` , {params}),
    // 根据信息获取商品信息列表
    getGoodsBy: (params) => request.get(`/cms/declare/getGoodsBy/` + params),
    // 根据条件查询台账信息
    getListBy: (params) => request.post(`/cms/declare/getListBy/` , params),
    // 根据id查询报关单详情
    getDetailById: (params) => request.get(`/cms/declare/getDetailById/` + params),
    // 根据id查报关单状态
    getStatusListBy: (params) => request.get(`/cms/declare/getStatusListBy/` + params),
    // 根据id查报关单错误
    getDeclareErrorMessage: (params) => request.get(`/cms/declare/getDeclareErrorMessage/` + params),
    // 货物暂存
    saveDecInfo: (params) => request.post(`/cms/declare/saveDecInfo`, params),
    // 批量复审
    batchAudit: (params) => request.post(`/cms/declare/batchAudit`, params),
    // 随附单证上传文件
    uploadFile: (interId,type,params) => request.post(`cms/declare/uploadFile?type=` + type +`&interId=` + interId ,params),
    // 电子档案批量上传
    upLoadDeclFiles: (fileType,rule,params) => request.post(`cms/uploadDeclBill/upLoadDeclFiles?fileType=` + fileType +`&rule=` + rule ,params),
    // 查询上传单证
    declareGetFiles: (interId) => request.get(`cms/declare/getFiles/` + interId),
    // 删除单证上传文件
    deleteFile: (id) => request.delete(`cms/declare/deleteFile/` + id),
    // 删除报关单
    deleteDecInfo: (id) => request.delete(`cms/declare/deleteDecInfo/` + id),
    // 预审和申报时错误记录
    insWrongRecord: (wrongInfo,contrNo,billNo,headId) => request.post(`cms/declare/insWrongRecord?wrongInfo=` + wrongInfo + '&contrNo=' +contrNo + '&billNo=' + billNo + '&headId=' + headId),
    // 查询错误记录
    getWrongRecord: (params) => request.post(`cms/declare/getWrongRecord` , params),
    // 驳回
    reject: (id, reason) => request.put(`cms/declare/reject/` + id + '/' + reason),
    // 保存核注清单
    saveInvInfo: (params) => request.post(`cms/invDeclare/saveInvInfo` , params),
    // 申报核注清单
    declareInvXml: (params) => request.post(`cms/invDeclare/declareInvXml` , params),
    // 查询核注清单列表
    getInvListBy: (params) => request.post(`cms/invDeclare/getInvListBy` , params),
    // 根据id查询核注详情
    getInvBy: (id) => request.get(`cms/invDeclare/getInvBy/` + id),
    // 删除核注清单
    deleteInvInfo: (id) => request.delete(`cms/invDeclare/deleteInvInfo/` + id),
    // 禁止类商品
    getProhibitGoods: (params) => request.get(`cms/baseInfo/getProhibitGoods` , {params}),
    // 修改、新增禁止类商品
    saveOrUpdateProhibitGood: (params) => request.post(`cms/baseInfo/saveOrUpdateProhibitGood` , params),
    // 删除禁止类商品
    deleteProhibitGood: (id) => request.delete(`cms/baseInfo/deleteProhibitGood/` + id), 
    // 上传单据
    getDeclaredBills: (params) => request.post(`cms/uploadDeclBill/getDeclaredBills` , params), 
    // 台账导入excel
    swBill: (params) => request.post(`cms/impExcel/swBill` , params), 
    // 写入东胜
    insData: (params) => request.post(`cms/impExcel/insData` , params), 
    // 仓库
    getInfo: (params) => request.get(`ckInfo/getInfo` , {params}),
    getCkNamesBy: () => request.get(`wms/task/getCkNamesBy`),
    
    // 查询仓库地址下仓库
    getStore: (params) => request.get(`ckInfo/getStore/` + params ),
    // 新增仓库
    insStore: (params) => request.post(`ckInfo/insStore` , params),
    // 获取库位信息
    getLocation: (params) => request.get(`ckInfo/getLocation/` + params ),
    // 新增库位
    insLocation: (params) => request.post(`ckInfo/insLocation` , params),
    // 获取货物信息
    wmsgetListBy: (pageNum,pageSize,params) => request.get(`wmsGoods/getListBy/` + pageNum + '/' + pageSize , {params} ),
    // 新增货物
    wmsinsGoods: (params) => request.post(`wmsGoods/insGoods` , params),
    // 查询账册
    wmsgetHandBook: (params) => request.get(`wms/handBook/getHandBook` , {params} ),
    // 新增账册
    wmsinsHandBook: (params) => request.post(`wms/handBook/insHandBook` , params),
    // 改变账册状态
    wmschangeHandBookStatus: (id) => request.put(`wms/handBook/changeHandBookStatus/` + id),
    // 保存仓库人员权限
    assignWmsUser: (id,userList) => request.post(`ckInfo/assignWmsUser/` + id , userList),
    // 获取仓库人员权限
    getWmsUser: (id) => request.get(`ckInfo/getWmsUser/` + id),
    // 保存入库任务单表头
    saveMain: (params) => request.post(`wms/task/saveMain` , params),
    // 获取入库任务单列表
    getWMSTaskList: (pageSize,pageNum,params) => request.post(`wms/task/getList/` + pageSize + '/' + pageNum, params ),
    // 获取单据编号
    getWMSBillNo: (params) => request.get(`/standard/getBillNo/` + params ),
    // 查看入库任务单详情
    getWMSTaskDetail: (id) => request.get(`wms/task/getTaskDetail/` + id ),
    // 删除入库任务单
    deleteWMSTask: (id) => request.delete(`wms/task/delete/` + id ),
    // 保存主任务中下发任务
    insOneRecordWMSTask: (params) => request.post(`wms/task/insOneRecord` , params ),
    // 下发暂存任务单
    wmsSaveOpTask: (params) => request.post(`wms/taskOp/saveOpTask` , params ),
    // 查询下发任务表格
    wmsGetOpsBySubId: (id) => request.get(`wms/taskOp/getOpsBySubId/` + id ),
    // 查询所有下发任务
    wmsGetOpsByTaskId: (id) => request.get(`wms/taskOp/getOpsByTaskId/` + id ),
    // 下发任务（批量入库）
    wmspushOpTask: (id) => request.post(`wms/taskOp/pushOpTask/` , id ),
    // 删除作业单(入库)
    wmsDeleteOp: (id) => request.delete(`wms/taskOp/deleteOp/` + id ),
    // 批量添加项号
    wmsUpdateItemNo: (itemNo,params) => request.post(`wms/task/updateItemNo/` + itemNo , params ),
    // 完成任务
    wmsinBoundTask: (params) => request.post(`wms/stock/inBound` , params ),
    // 查询库存
    wmsGetStockList: (params) => request.post(`wms/stock/getStockList` , params ),
    // 扣除库存
    wmsOutStock: (params) => request.post(`wms/stock/outStock` , params ),
    // 删除出库计划
    wmsRemoveDetailById: (id) => request.post(`wms/stock/removeDetailById/` + id ),
    // 入库删除计划信息
    wmsDeleteSubs: (id) => request.delete(`wms/task/deleteSubs/` + id ),
  };
